import React, { useState } from "react";
import ConfirmDialog from "../../../../components/genericform/ConfirmDialog";
import { notifySuccess } from "src/assets/toastService";

interface DeleteStaffDialogProps {
  open: boolean;
  staffName: string;
  isProcessing?: boolean;
  onClose: () => void;
  onDelete: () => Promise<boolean> | boolean;
}

const DeleteStaffDialog: React.FC<DeleteStaffDialogProps> = ({
  open,
  staffName,
  isProcessing: externalProcessing = false,
  onClose,
  onDelete,
}) => {
  const [internalProcessing, setInternalProcessing] = useState(false);
  const isProcessing = externalProcessing || internalProcessing;

  const handleDelete = async () => {
    if (isProcessing) return;
    
    setInternalProcessing(true);
    try {
      const success = await onDelete();
      
      if (success) {
        // Small delay to ensure toast is shown before closing
        setTimeout(() => {
          notifySuccess(`Staff member "${staffName}" deleted successfully.`);
          onClose();
          setInternalProcessing(false);
        }, 1000);
      } else {
        setInternalProcessing(false);
      }
    } catch (error) {
      console.error("Error in handleDelete:", error);
      setInternalProcessing(false);
    }
  };

  const handleClose = () => {
    if (!isProcessing) {
      onClose();
    }
  };

  // Check if ConfirmDialog accepts isProcessing prop, if not, remove it
  return (
    <ConfirmDialog
      open={open}
      title="Confirm To Delete"
      description={`Are you sure you want to delete the staff member: "${staffName}"?`}
      confirmLabel="Delete"
      cancelLabel="Cancel"
      onConfirm={handleDelete}
      onCancel={handleClose}
    />
  );
};

export default DeleteStaffDialog;